import { render } from "./HistoriqueSection.vue?vue&type=template&id=07fea0e6"
import script from "./HistoriqueSection.vue?vue&type=script&lang=js"
export * from "./HistoriqueSection.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__